<template>
  <div>
    <div class="fixed width-100 z-99">
      <van-tabs v-model="tabIndex">
        <van-tab title="发起提交"></van-tab>
        <van-tab title="查看数据"></van-tab>
      </van-tabs>
    </div>
    <!--  站位盒子  -->
    <div class="h-98"></div>
    <!--  列表  -->
    <list v-if="tabIndex === 1" ref="list" @change="listChange"></list>
    <!--  表单  -->
    <addOrUpdate v-if="tabIndex === 0" ref="addOrUpdate"></addOrUpdate>


  </div>
</template>
<script>
import list from "./list.vue";
import addOrUpdate from "./form.vue";

export default {
  components: {addOrUpdate, list},
  data(){
    return {
      tabIndex: 0
    }
  },
  methods:{
    listChange(data) {
      const {processInstanceId, taskId} = data
      const query = {
        ...this.$route.query, processInstanceId, taskId
      }
      window.location.href = `${window.location.origin}${window.location.pathname}?processInstanceId=${processInstanceId}&taskId=${taskId}&groupId=${query.groupId}&templateId=${query.templateId}`
    }
  }
}
</script>